(ns ui.components.breadcrumbs.view
  (:require [ui.dom-globals :as dg]))

;; Refactored container: avoids brittle CSS, corrects first/last logic, avoids repeated (count children)
(defn container
  [& children]
  (let [children (vec children)
        last-idx (dec (count children))]
    [:div
     {:class "flex h-full items-center gap-2 font-semibold"}
     (->> children
          (map-indexed
           (fn [idx child]
             (let [last? (= idx last-idx)
                   first? (= idx 0)]
               ^{:key (str "bread-crumb-item-" idx)}
               [:div
                {:class "flex items-center gap-2"}

                ;; Home icon for the first breadcrumb
                (when first?
                  [:img
                   {:src "/img/home-solid.svg"
                    :alt ""
                    :class "w-4 h-4 opacity-70"}])

                child

                ;; Separator for all but the last breadcrumb
                (when-not last?
                  [:span {:class "text-base-light-text-paler"} "/"])]))))]))

(defn item
  [{:keys [on-click active?]} label]
  [:div
   (if (or active?
           (not (fn? on-click)))
     [:span
      {:class "text-base-light-text"}
      label]
     [:a
      {:class    "group inline-flex items-center gap-2 text-base-light-text-paler hover:text-base-light-text-accent underline-offset-4"
       :href     "#"
       :on-click (fn [e]
                   (dg/prevent-and-stop e)
                   (when on-click
                     (on-click))
                   false)}
      [:span
       {:class "group-hover:underline"}
       label]])])

(defn view
  [{:keys [items]}]
  (into (container)
        (->> items
             (map (fn [{:keys [active? on-click label]}]
                    [item {:active?  active?
                           :on-click on-click} label])))))
